export default "__VITE_ASSET__CXEhXlPp__"